// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__2S6Ci","modalHeader":"modal_modalHeader__dblmz","close":"modal_close__m4Tok","modalContent":"modal_modalContent__PriBE","modalFooter":"modal_modalFooter__0oaQq"};